export default "__VITE_ASSET__Cq8M2poO__"